export const env = {
  VITE_BASE_API: import.meta.env.VITE_BASE_API,
  VITE_RECAPTCHA_SITE_KEY: import.meta.env.VITE_RECAPTCHA_SITE_KEY,
  VITE_RECAPTCHA_DOMAINS: import.meta.env.VITE_RECAPTCHA_DOMAINS,
  VITE_MIXPANEL_TOKEN: import.meta.env.VITE_MIXPANEL_TOKEN,
  VITE_MIXPANEL_APP_ORIGIN: import.meta.env.VITE_MIXPANEL_APP_ORIGIN,
  VITE_LAUNCHDARKLY_CLIENT_ID: import.meta.env.VITE_LAUNCHDARKLY_CLIENT_ID,
}
